export default __webpack_public_path__ + "static/media/olives.2f7024fd.webp";